import { useEffect, useRef, useState } from "react";
import { AppIcons } from "../../../data/appIcons";
import Image from "../../image/Image";
import Buttons from "../../ui/button/Buttons";
import { Link } from "react-router-dom";
import { useAsync } from "react-select/async";
import { useCol } from "react-bootstrap/esm/Col";
import Iconify from "../../iconify/iconify";
import { DropdownWrapper } from "../../FinalMolGrid/ui/dropdownWrapper/DropdownWrapper";

const RenderGridAction = ({ rowData, col, rowIndex, onActionHandler, setEditableGrid, editingRow, editSelectedRow, canceeEditGrid }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);


  if (!col.defaultAction) {
    col.defaultAction = {
      allowEdit: true,
      allowDelete: true,
    };
  }

  if (col.renderCustomAction) {
    col?.renderCustomAction(rowData, col);
  }

  const handleAction = (actionName, data, rowIndex) => {
    if (col.editableGrid && actionName === 'EDIT') {
      setEditableGrid(data, rowIndex);
    }
    else if (col.editableGrid && actionName === 'CANCEL') {
      canceeEditGrid();
    }
    else if (onActionHandler) {
      if (onActionHandler[actionName]) {
        onActionHandler[actionName](data, col);
      }
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };



  return (
    <div className="d-flex action-button">
      {col.customActions && col.customActions.length > 0 && (
        <div
          className={`dropdown-action ${isDropdownOpen ? "openAction" : ""}`}
          ref={dropdownRef}
        >
          <Buttons
            buttonTypeClassName="btn-drop"
            textWithIcon={true}
            imagePath={AppIcons.arrowIcon}
            onClick={toggleDropdown}
          ></Buttons>
          <div className="dropdown-list">
            <ul>
              {col.customActions.map((action, index) => {
                return <li key={`customAction_${index}`}>
                  <Link onClick={closeDropdown} to={action.path}>
                    {action.name}
                  </Link>
                </li>
              })}
            </ul>
          </div>
        </div>
      )}
      {/* Custom Wrapper Actions */}
      {col.customWrapper?.length > 0 && (
        <DropdownWrapper
          toggleElement={
            <div className="custom-wrapper-actions">
              <Iconify icon="gridicons:dropdown" altText="More Actions" />
            </div>
          }
        >
          <div className="dropdown-box">
            {col.customWrapper.map((wrapper, index) => (
              <button
                key={`customWrapper_${index}`}
                onClick={() => handleAction(wrapper.name, rowData, rowIndex)}
                className="dropdown-item" // Add your styling here
              >
                {wrapper.label}
              </button>
            ))}
          </div>
        </DropdownWrapper>
      )}
      {col.customAction &&
        col.customAction.length > 0 &&
        col.customAction.map((action, index) => {
          const commonLinkProps = {
            key: `customAction_${index}`,
            onClick: (e) => {
              if (rowData?.isDisabled) {
                e.preventDefault();
                return;
              }
              e.preventDefault();
              handleAction(action.name, rowData);

            },
            // className: "mr-4",
            className: rowData?.isDisabled ? "mr-4 disabled-link" : "mr-4",
            title:  !rowData?.isDisabled && action.name,
            href: "",

          };
          // Add condition to check if rowData.contractInputFile is present
          if (action.name === "" && !rowData.contractInputFile) {
            return null;
          } else {
            // Render null if rowData.contractInputFile is not present
            return (
              <>
                {action.iconNam ? <Link {...commonLinkProps}>
                  <Image imagePath={action.iconName} altText={action.name} />
                </Link> :
                  <Link className={"text-decoration-underline"} {...commonLinkProps}>{action.name}</Link>
                }
              </>
            );
          }
        })}

      {editingRow && col.editableGrid && col.defaultAction?.allowEdit ?
        <>
          <Link
            onClick={(e) => {
              e.preventDefault();
              setEditableGrid(null)
              handleAction("SAVE", editSelectedRow, rowIndex);
            }}
            className="mr-4"
            title="SAVE"
          >
            <Image imagePath={AppIcons.sucessIcon} altText="Save Icon" />
          </Link>
          <Link
            onClick={(e) => {
              e.preventDefault();
              handleAction("CANCEL", rowData, rowIndex);
            }}
            className="mr-4"
            title="CANCEL"
          >
            <Image imagePath={AppIcons.checkNot} altText="Cancel Icon" />
          </Link>
        </>
        :
        <>
          {
            col.defaultAction?.allowEdit && (
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  handleAction("EDIT", rowData, rowIndex);
                }}
                className="mr-4"
                title="EDIT"
              >
                <Image imagePath={AppIcons.editIcon} altText="Edit Icon" />
              </Link>
            )
          }

          {col.defaultAction?.allowDelete && (
            <Link
              onClick={(e) => {
                e.preventDefault();
                handleAction("DELETE", rowData);
              }}
              className="mr-4"
              title="DELETE"
            >
              <Image imagePath={AppIcons.deleteIcon} altText="Delete Icon" />
            </Link>
          )}
        </>
      }

    </div>
  );
};
export default RenderGridAction